import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/ui';
import { useDigitalProduct } from 'modules/digital-product/hooks/use-digital-product';
import PricePlans from 'modules/digital-product/price-plans';
import { PricePlanType } from '@systemeio/types';
import { usePaymentMethods } from 'modules/payment-methods/hooks/use-payment-methods';
import React, { FC } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { Loader } from 'shared/components/loader';
import { SectionMessage } from 'shared/components/section-message';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
type Props = {
  pricePlans: PricePlanType[];
  onChange: (pricePlans: PricePlanType[]) => void;
  currency?: CurrencyEnum;
  errors: string[];
  digitalProductId?: number | null;
};
export const PricePlanItem: FC<Props> = t0 => {
  const $ = _c(21);
  const {
    pricePlans,
    onChange,
    currency,
    errors,
    digitalProductId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data: paymentMethodsData
  } = usePaymentMethods(currency);
  const {
    mutate
  } = useDigitalProduct(digitalProductId);
  let t1;
  if ($[0] !== mutate) {
    t1 = async pricePlans_0 => {
      await mutate(data => data && {
        ...data,
        pricePlans: pricePlans_0
      }, false);
    };
    $[0] = mutate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const mutatePricePlans = t1;
  if (!currency) {
    let t2;
    if ($[2] !== t) {
      t2 = t("dashboard.store.product.choose_currency");
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <SectionMessage className="w-full">{t2}</SectionMessage>;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== errors) {
      t4 = errors.join(", ");
      $[6] = errors;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t4) {
      t5 = <FieldErrorAndDescription error={t4} />;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== t3 || $[11] !== t5) {
      t6 = <div className="flex flex-col items-center gap-1">{t3}{t5}</div>;
      $[10] = t3;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  if (!paymentMethodsData) {
    let t2;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Loader />;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    return t2;
  }
  let t2;
  if ($[14] !== currency || $[15] !== errors || $[16] !== mutatePricePlans || $[17] !== onChange || $[18] !== paymentMethodsData.paymentMethods || $[19] !== pricePlans) {
    t2 = <PricePlans errors={errors} currency={currency} paymentMethods={paymentMethodsData.paymentMethods} maxPricePlans={Infinity} pricePlans={pricePlans} onChanePricePlans={onChange} mutatePricePlans={mutatePricePlans} />;
    $[14] = currency;
    $[15] = errors;
    $[16] = mutatePricePlans;
    $[17] = onChange;
    $[18] = paymentMethodsData.paymentMethods;
    $[19] = pricePlans;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  return t2;
};